import { StateCreator } from 'zustand';
import { AuthStore, User } from '../../@types/auth';

const createAuthSlice: StateCreator<
  AuthStore,
  [["zustand/devtools", never]],
  [],
  AuthStore
> = (set) => ({
  user: null,
  setUser: (data: User) => set(() => ({ user: data }), false, 'setUser'),
  logout: () => set(() => ({ user: null }), false, 'logout'),
})

export default createAuthSlice
